import { render, staticRenderFns } from "./CreateAnnouncementImageUploader.vue?vue&type=template&id=68df0910&scoped=true&"
import script from "./CreateAnnouncementImageUploader.vue?vue&type=script&lang=js&"
export * from "./CreateAnnouncementImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./CreateAnnouncementImageUploader.vue?vue&type=style&index=0&id=68df0910&lang=scss&scoped=true&"
import style1 from "./CreateAnnouncementImageUploader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68df0910",
  null
  
)

export default component.exports